module.exports = __webpack_public_path__ + "img/hs-07.0d2c6f88.svg";